import {Component, Module} from 'app/decorators';
import _ from 'lodash';

import ProductRateStore from 'app/stores/product.rate';


@Module({
    name: "app.directives.fiters.active",
})
@Component({
    selector: 'blnd-active-filter',
    bindings: {
        ngModel: '=',
        ngChange: '&?',
    },
    template: `<select class="form-control" ng-model="$ctrl.ngModel" ng-options="key for (key, value) in $ctrl.options"><option value="">Show all</option></select>`,
})
export default class C {
    constructor($scope) {
        "ngInject";
        this.$scope = $scope;
        this.options = {
            'Active': 'yes',
            'Inactive': 'no',
        }
    }

    $onInit () {
        let self = this;
        self.$scope.$watch(() => self.ngModel, () => {
            self.onChange();
        })
    }

    onChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/active.filter.js